import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../../components/Forms/Form/Form';
import { withAppContext } from '../../contexts/AppContext';

import './ProfileDeliveryAddresses.css'; 

class ProfileDeliveryAddresses extends React.Component {
    
    state = {
      visible: false,
    };

    constructor(props) {
      super(props);
      
      this.appRef = this.props.appContext?.appRef || null;
      this.formRef = React.createRef();
    }

    hiddens = {
      count_address_P: 0,
      count_address_B: 0,
      delete_address_B:'',
      delete_address_P:'',
      new_address_B:'',
      new_address_P:''
    };

  /**
   * Form hívja meg ha változás történt egy mezőben
  */
  on_form_change(key, value) {
    
  }


  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {

    if(params.result?.user_data){
      this.appRef.current.setState({user_data: params.result.user_data}); // beállítjuk a bejelntkezés utáni állapotot
    }
    
    this.toggle();
  }

  toggle() {
    this.setState({visible: !this.state.visible});
  }

  handleWrapperClick = (e) => {
    // Új cím / Törlés gomb kezelése
    const button = e.target.closest('button.default_button');
    if (button) {
      e.preventDefault();

      const buttonType = button.getAttribute('data-button-type');
      
      const form = this.formRef.current;
      if (!form) return;

      const formData = { ...form.state.formData };

      if (buttonType === 'delete') {  
        let count = parseInt(formData['count_address_P'] || 0, 10);
        formData['delete_address_P'] = count;
      } else {
        // Új cím gomb - csak jelezzük, NEM növeljük a count-ot
        formData['new_address_P'] = '1';
      }
      
      const idInputs = document.querySelectorAll('input[id^="id_P_"]');
      idInputs.forEach(input => {
          formData[input.id] = input.value;
      });

      form.setState({ formData }, () => {
          form.load_form_data(true);
      });

      return;
    }

    // Submit gomb kezelése
    const submitButton = e.target.closest('input[type="submit"]');
    if (submitButton) {
      e.preventDefault();
      
      const form = this.formRef.current;
      if (!form) return;

      const formData = { ...form.state.formData };
      
      // Ha new_address_P be van állítva, MOST növeljük a count_address_P-t
      if (formData['new_address_P'] == '1') {
        let count = parseInt(formData['count_address_P'] || 0, 10);
        formData['new_address_P'] = '';
        formData['count_address_P'] = count + 1;
      }
      
      // id_P_* mezők begyűjtése
      const idInputs = document.querySelectorAll('input[id^="id_P_"]');
      idInputs.forEach(input => {
          formData[input.id] = input.value;
      });

      form.setState({ formData }, () => {
          form.handle_submit({ preventDefault: () => {} });
      });
    }
  }

  render() { 

    if (!this.state.visible) {
      return null;
    }

    return <div className={`container floating_container page_account_settings`}>
      <div className='floating_container_header no_drop_shadow no_border'>
        <PageHeader isHistoryBack={false} no_close={true} callback={() => this.toggle()} title={i18n.t('accountSettingsDeliveryAddressesTitle')}></PageHeader>
      </div>
      <div className="floating_container_content">
        <div className="form_wrapper" onClick={this.handleWrapperClick}> 
            <Form 
              onSuccess={(params) => {this.on_submit_success(params)}} 
              ref={this.formRef} 
              hiddens={this.hiddens} 
              name="account_settings" 
              submit_text={i18n.t('accountSettingsSubmit')} 
              others={{'form_parts': 'delivery_datas_block'}}
              parent={this} />
        </div>
      </div>
    </div>;
  }

}


export default withAppContext(ProfileDeliveryAddresses);